import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider, createBrowserHistory } from '@tanstack/react-router'

import { getTenantAccess, hasTenantPermissions } from '@authy/lib-common/utils/tenant'

import { appState, initAppState } from '@/appState'

import '@/i18n'
import '@/index.css'

import { router } from './router'

const main = async () => {
    await initAppState()

    const history = createBrowserHistory()

    if (!history.location.pathname.split('/')[1]) {
        //
        // Auto-choose the initial tenant by either taking the only one available
        // or checking the last one user has been using
        //

        let startTenantShortId: string = localStorage.getItem('lastTenantShortId') || ''

        if (startTenantShortId && !appState.userTenants.find(({ shortId }) => shortId === startTenantShortId)) {
            startTenantShortId = ''
        }

        if (!startTenantShortId && appState.userTenants.length === 1) {
            startTenantShortId = appState.userTenants[0].shortId
        }

        if (startTenantShortId) {
            const tenantId = appState.userTenants.find((o) => o.shortId === startTenantShortId)?._id
            const tenantAccess = tenantId && getTenantAccess({ user: appState.user!, tenantId })

            if (hasTenantPermissions(tenantAccess, { tenant: { read: true } })) {
                history.replace(`/${startTenantShortId}`)
            }
        }
    }

    createRoot(document.getElementById('root')!).render(
        <StrictMode>
            <RouterProvider router={router} history={history} />
        </StrictMode>
    )
}

main()
